import React from 'react'
import { Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import {
  HomePage,
  PrivacyPolicy,
  ProductsPage,
  TermsOfService,
  TrackingPage,
  WasteCollectionEntryPoint,
  WasteCollectionLayout,
  WasteCollectionPage,
} from 'src/pages'
import { Layout } from 'src/components/Layout'

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path='*' element={<HomePage />} />
          <Route path='/d/:trackingId' element={<TrackingPage />} />
          <Route path='/terms-of-delivery' element={<TermsOfService />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/checkout' element={<PrivacyPolicy />} />
        </Route>
        <Route  path='/noutotilaus' element={<WasteCollectionLayout />}>
          <Route index element={ <WasteCollectionEntryPoint /> } />
          <Route path=':storeId' element={ <WasteCollectionPage /> } />
        </Route>
      </Routes>
    </Router>
  )
}

export default AppRoutes
